import { useState, useCallback } from 'react';

const useSlideAnimation = (initialPanel = 'user-management') => {
  const [activePanel, setActivePanel] = useState(initialPanel);
  const [slideDirection, setSlideDirection] = useState('next');

  const slideTo = useCallback((targetPanel) => {
    if (targetPanel === activePanel) return;
    
    // Determine slide direction based on panel index
    const direction = targetPanel > activePanel ? 'next' : 'prev';
    setSlideDirection(direction);
    setActivePanel(targetPanel);
  }, [activePanel]);

  const slideNext = useCallback((panels) => {
    const currentIndex = panels.findIndex(panel => panel.id === activePanel);
    if (currentIndex < panels.length - 1) {
      slideTo(panels[currentIndex + 1].id);
    }
  }, [activePanel, slideTo]);

  const slidePrev = useCallback((panels) => {
    const currentIndex = panels.findIndex(panel => panel.id === activePanel);
    if (currentIndex > 0) {
      slideTo(panels[currentIndex - 1].id);
    }
  }, [activePanel, slideTo]);

  return {
    activePanel,
    slideDirection,
    slideTo,
    slideNext,
    slidePrev
  };
};

export default useSlideAnimation; 